import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { comics } from '@/mocks/comics';

const chapterPages: Record<string, string[]> = {
  'ch-1': [
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20illustration%20beautiful%20detailed%20artwork%20with%20characters%20and%20dialogue%20bubbles%20professional%20manga%20style%20warm%20tones%20clean%20lineart&width=1200&height=800&seq=chapter-p1-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20with%20romantic%20scene%20two%20characters%20talking%20soft%20expression%20detailed%20lineart%20professional%20style&width=1200&height=900&seq=chapter-p1-2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20dramatic%20moment%20close-up%20character%20expression%20emotional%20scene%20detailed%20artwork&width=1200&height=1000&seq=chapter-p1-3&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20outdoor%20scene%20beautiful%20background%20characters%20interacting%20professional%20illustration&width=1200&height=800&seq=chapter-p1-4&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20tense%20moment%20characters%20confrontation%20detailed%20artwork%20with%20dialogue&width=1200&height=950&seq=chapter-p1-5&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20climax%20scene%20dramatic%20composition%20beautiful%20illustration%20professional%20style&width=1200&height=850&seq=chapter-p1-6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20resolution%20scene%20soft%20mood%20characters%20emotional%20detailed%20lineart&width=1200&height=900&seq=chapter-p1-7&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20ending%20scene%20beautiful%20composition%20warm%20tones%20professional%20illustration&width=1200&height=1000&seq=chapter-p1-8&orientation=portrait',
  ],
  'ch-2': [
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20unexpected%20encounter%20scene%20two%20characters%20surprised%20expression%20detailed%20artwork&width=1200&height=800&seq=chapter-p2-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20conversation%20scene%20cafe%20setting%20characters%20chatting%20professional%20illustration&width=1200&height=850&seq=chapter-p2-2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20emotional%20scene%20close-up%20expression%20detailed%20lineart%20warm%20tones&width=1200&height=950&seq=chapter-p2-3&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20walking%20together%20street%20scene%20beautiful%20background%20professional%20style&width=1200&height=800&seq=chapter-p2-4&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20intimate%20moment%20romantic%20tension%20characters%20close%20detailed%20artwork&width=1200&height=900&seq=chapter-p2-5&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20sunset%20scene%20beautiful%20colors%20characters%20silhouette%20professional%20illustration&width=1200&height=1000&seq=chapter-p2-6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20heartfelt%20dialogue%20scene%20emotional%20expression%20detailed%20lineart&width=1200&height=800&seq=chapter-p2-7&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20closing%20scene%20gentle%20mood%20warm%20atmosphere%20professional%20style&width=1200&height=850&seq=chapter-p2-8&orientation=portrait',
  ],
  'ch-3': [
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20morning%20scene%20character%20waking%20up%20soft%20lighting%20detailed%20illustration&width=1200&height=800&seq=chapter-p3-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20school%20setting%20characters%20in%20classroom%20professional%20artwork%20clean%20style&width=1200&height=900&seq=chapter-p3-2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20heartbeat%20moment%20blushing%20expression%20romantic%20tension%20detailed%20lineart&width=1200&height=950&seq=chapter-p3-3&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20lunch%20scene%20characters%20eating%20together%20casual%20atmosphere%20illustration&width=1200&height=800&seq=chapter-p3-4&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20emotional%20confrontation%20dramatic%20scene%20close-up%20eyes%20detailed%20artwork&width=1200&height=1000&seq=chapter-p3-5&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20after%20school%20scene%20walking%20home%20sunset%20warm%20colors%20professional&width=1200&height=850&seq=chapter-p3-6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20night%20scene%20characters%20texting%20phone%20glow%20intimate%20mood%20detailed&width=1200&height=900&seq=chapter-p3-7&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20anticipation%20moment%20character%20looking%20forward%20hopeful%20expression%20illustration&width=1200&height=950&seq=chapter-p3-8&orientation=portrait',
  ],
};

const defaultPages: string[] = [
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20illustration%20beautiful%20detailed%20artwork%20with%20characters%20and%20dialogue%20bubbles%20professional%20manga%20style%20warm%20tones%20clean%20lineart&width=1200&height=800&seq=chapter-default-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20with%20romantic%20scene%20two%20characters%20talking%20soft%20expression%20detailed%20lineart%20professional%20style&width=1200&height=900&seq=chapter-default-2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20dramatic%20moment%20close-up%20character%20expression%20emotional%20scene%20detailed%20artwork&width=1200&height=1000&seq=chapter-default-3&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20outdoor%20scene%20beautiful%20background%20characters%20interacting%20professional%20illustration&width=1200&height=800&seq=chapter-default-4&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20tense%20moment%20characters%20confrontation%20detailed%20artwork%20with%20dialogue&width=1200&height=950&seq=chapter-default-5&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20climax%20scene%20dramatic%20composition%20beautiful%20illustration%20professional%20style&width=1200&height=850&seq=chapter-default-6&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20resolution%20scene%20soft%20mood%20characters%20emotional%20detailed%20lineart&width=1200&height=900&seq=chapter-default-7&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manga%20comic%20page%20ending%20scene%20beautiful%20composition%20warm%20tones%20professional%20illustration&width=1200&height=1000&seq=chapter-default-8&orientation=portrait',
];

export default function ChapterReadingPage() {
  const { slug, chapterId } = useParams<{ slug: string; chapterId: string }>();
  const comic = comics.find((c) => c.slug === slug);
  const chapter = comic?.chapters.find((ch) => ch.id === chapterId);
  const pages = (chapterId && chapterPages[chapterId]) ? chapterPages[chapterId] : defaultPages;

  if (!comic || !chapter) {
    return (
      <>
        <Navbar />
        <div className="pt-20 flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-800 mb-4">内容未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 whitespace-nowrap">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const currentIndex = comic.chapters.findIndex((ch) => ch.id === chapterId);
  const prevChapter = currentIndex < comic.chapters.length - 1 ? comic.chapters[currentIndex + 1] : null;
  const nextChapter = currentIndex > 0 ? comic.chapters[currentIndex - 1] : null;

  return (
    <>
      <Navbar />
      <Breadcrumb />
      <main className="bg-foreground-950 min-h-screen">
        <div className="sticky top-16 z-30 bg-foreground-950/95 backdrop-blur-md border-b border-foreground-800/50 w-full px-4 md:px-6 py-3">
          <div className="flex items-center justify-between max-w-3xl mx-auto">
            <Link to={`/comic/${comic.slug}`} className="text-foreground-400 hover:text-white text-sm transition-colors flex items-center gap-1 whitespace-nowrap">
              <i className="ri-arrow-left-line text-sm w-4 h-4 flex items-center justify-center" />
              {comic.title}
            </Link>
            <h1 className="text-sm font-medium text-white truncate px-4">{chapter.title}</h1>
            <div className="flex items-center gap-2">
              {prevChapter && (
                <Link
                  to={`/comic/${comic.slug}/chapter/${prevChapter.id}`}
                  className="flex items-center gap-1 text-xs text-foreground-400 hover:text-white transition-colors px-3 py-1.5 rounded-full border border-foreground-700 whitespace-nowrap"
                >
                  <i className="ri-arrow-up-line text-xs w-3 h-3 flex items-center justify-center" />
                  上一话
                </Link>
              )}
              {nextChapter && (
                <Link
                  to={`/comic/${comic.slug}/chapter/${nextChapter.id}`}
                  className="flex items-center gap-1 text-xs text-foreground-400 hover:text-white transition-colors px-3 py-1.5 rounded-full border border-foreground-700 whitespace-nowrap"
                >
                  下一话
                  <i className="ri-arrow-down-line text-xs w-3 h-3 flex items-center justify-center" />
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto px-4 md:px-6 py-8">
          <div className="text-center mb-10">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">{chapter.title}</h2>
            <p className="text-foreground-500 text-xs">{chapter.date}</p>
          </div>

          <div className="flex flex-col gap-4">
            {pages.map((pageUrl, i) => (
              <div key={i} className="rounded-xl overflow-hidden bg-background-800/50">
                <img
                  src={pageUrl}
                  alt={`${comic.title} - ${chapter.title} 第${i + 1}页`}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-between flex-wrap gap-3">
            {prevChapter ? (
              <Link
                to={`/comic/${comic.slug}/chapter/${prevChapter.id}`}
                className="flex items-center gap-2 bg-background-800 hover:bg-background-700 text-white px-5 py-3 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line text-sm w-4 h-4 flex items-center justify-center" />
                上一话
              </Link>
            ) : (
              <div />
            )}

            <Link
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-5 py-3 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              返回目录
              <i className="ri-list-check text-sm w-4 h-4 flex items-center justify-center" />
            </Link>

            {nextChapter ? (
              <Link
                to={`/comic/${comic.slug}/chapter/${nextChapter.id}`}
                className="flex items-center gap-2 bg-background-800 hover:bg-background-700 text-white px-5 py-3 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                下一话
                <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
              </Link>
            ) : (
              <div />
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}